<template>
  <div class="d-flex align-items-center justify-content-between flex-wrap">
    <h4 class="text-main">
      {{ title }}
    </h4>
    <div class="d-flex align-items-center gap-16">
      <b-dropdown
        size="md"
        variant="white"
        :disabled="isEmpty"
        offset="-50"
        class="custom-dropdown shadow-sm"
      >
        <template #button-content>
          <div
            class="text-small text-main"
            @click="toggleOpen"
          >
            {{ filterName ? filterName : filter24Hr }}
            <GjIcon
              :class="isOpen ? 'arrow-down-icon text-main' : 'text-main'"
              name="ArrowDown"
              size="17"
            />
          </div>
        </template>
        <b-dropdown-item
          v-for="filter in analyticsFilter"
          :key="filter.id"
          @click="setFilterValue(filter)"
        >
          <div class="gap-5">
            <GjIcon
              :name="filter.iconName"
              size="18"
            />
            <span
              class="ml-1"
            >{{ filter.name }}</span>
          </div>
        </b-dropdown-item>
      </b-dropdown>
      <b-dropdown
        v-if="selectedAccount && !isForDistribution"
        id="object-options"
        :disabled="isEmpty"
        variant="bg-white"
        no-caret
      >
        <template
          #button-content
        >
          <img
            :src="selectedAccount.parentId === '0' ? require('@/assets/images/logo/Captain.svg') : selectedAccount.providerImageUrl"
            width="30px"
            height="30px"
            alt="Storage External Account"
            class="mr-1"
          >
          <span><b>{{ selectedAccount.parentId === '0' ? 'Captain' : selectedAccount.username }}</b></span>
          <GjIcon
            class="ml-1"
            name="ArrowDown"
          />
        </template>
        <ul
          v-for="(account, property) in externalAccounts"
          :key="property"
          class="list-unstyled m-0 p-0"
        >
          <b-dropdown-item
            @click="account.id !== selectedAccount.id ? changeSelectedAccount(account) : ''"
          >
            <div class="d-flex align-items-center">
              <img
                :src="account.parentId === '0' ? require('@/assets/images/logo/Captain.svg') : account.providerImageUrl"
                width="30px"
                height="30px"
                alt=""
                class="mr-1"
              >
              <div class="d-flex align-items-start flex-column">
                <span class=""><strong>{{ account.parentId === '0' ? 'Captain ' : account.username }}</strong></span>
                <span class="text-secondary text-sm"><strong>{{ account.bucketName ? account.bucketName : '' }}</strong></span>
              </div>
            </div>

          </b-dropdown-item>
        </ul>
      </b-dropdown>
      <multi-select
        ref="selectOptionsRef"
        :is-disabled="isAnyRequestLoading || isEmpty"
        :item-name="multiSelectTitle"
        :items="items"
        :selected-account="selectedAccount"
        :is-for-distribution="isForDistribution"
        @idsChanged="handleIdChanges"
        @fetchData="fetchScrolledItems"
      />
      <b-button
        :disabled="isAnyRequestLoading || filterInvalid"
        variant="primary"
        class="shadow-sm px-2"
        size="md"
        @click="applyFilters"
      >
        Apply
      </b-button>
    </div>
  </div>
</template>

<script>

import MultiSelect from '../components/MultiSelect.vue'

export default {
  name: 'CdnDashboard',
  components: {
    MultiSelect,
  },
  props: {
    items: {
      type: Array,
      default: () => ([]),
    },
    pageSize: {
      type: [String, Number],
      default: 10,
    },
    totalCount: {
      type: [String, Number],
      default: 0,
    },
    title: {
      type: String,
      default: 'Analytics Dashboard',
    },
    multiSelectTitle: {
      type: String,
      default: 'Options',
    },
    isAnyRequestLoading: {
      type: Boolean,
      default: false,
    },
    isForDistribution: {
      type: Boolean,
      default: false,
    },
    selectedAccount: {
      type: Object,
      default: null,
    },
    externalAccounts: {
      type: Array,
      default: () => ([]),
    },
  },
  data() {
    return {
      isOpen: false,
      currentPage: 0,
      filterName: '',
      filterValue: '',
      selectedIds: [],
      analyticsFilter: [
        {
          id: 1,
          name: 'Last 4 hours',
          value: '4-h',
          iconName: 'Time',
        },
        {
          id: 2,
          name: 'Last 12 hours',
          value: '12-h',
          iconName: 'Time',
        },
        {
          id: 3,
          name: 'Last 24 hours',
          value: '24-h',
          iconName: 'Time',
        },
        {
          id: 4,
          name: 'Last 48 hours',
          value: '48-h',
          iconName: 'Time',
        },
        {
          id: 5,
          name: 'Last 72 hours',
          value: '72-h',
          iconName: 'Time',
        },
        {
          id: 6,
          name: 'Last 4 days',
          value: '4-d',
          iconName: 'Time',
        },
        {
          id: 7,
          name: 'Last 30 days',
          value: '30-d',
          iconName: 'Time',
        },
      ],
    }
  },
  computed: {
    filter24Hr() {
      return this.analyticsFilter[2].name
    },
    isEmpty() {
      return this.items.length === 0
    },
    filterInvalid() {
      return this.selectedIds.length < 1
    },
  },
  watch: {
    selectedAccount() {
      if (!this.isForDistribution) {
        this.selectedIds = [this.items[0].name]
      }
    },
    filterValue() {
      this.$emit('changeFilter', this.filterValue)
    },
  },
  created() {
    if (!this.isForDistribution) {
      this.selectedIds = [this.items[0].name]
    }
  },
  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen
    },
    setFilterValue(filter) {
      this.filterName = filter.name
      this.filterValue = filter.value
    },
    handleIdChanges(v) {
      this.selectedIds = v
    },
    applyFilters() {
      const filterData = {
        filterName: this.filterValue || '4-h',
        selectedIds: this.selectedIds,
      }
      this.$emit('applyFilters', filterData)
    },
    fetchScrolledItems(query) {
      this.$emit('fetchScrolledItems', query)
    },
    changeSelectedAccount(account) {
      this.$emit('changeSelectedAccount', account)
    },
  },
}
</script>
<style lang="scss" scoped>
.arrow-down-icon {
  rotate: 180deg;
}
.gap-16{
  gap:16px
}

.custom-dropdown {
  ::v-deep {
    .dropdown-toggle::after {
      display: none;
    }
    .dropdown-menu {
      height: auto;
      overflow-y: auto;
      max-height: 250px;
      margin-top: 6px;
      min-width: 132px;
    }
  }

}

</style>
